import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useIsUserLoggedIn } from '../modules/auth/auth.utils';

export const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const isAuthenticated = useIsUserLoggedIn();
  return (
    <Route
      key={document.location.href}
      {...rest}
      component={(props) =>
        isAuthenticated && restricted ? (
          <div>
            <Redirect to='/admin' />
          </div>
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
